import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, InputLabel, TextField, Tooltip, Typography } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { getOnBoardCompliance, postAddOnBoardCompliance } from 'redux/actions/UserCompliance';
import { dateFormate, truncateComment } from 'utils/utils';
import { complianceObject, dateObject } from 'utils/enumObject';  
import Loader from 'components/loader/Loader';
import closebtn from "assets/images/CrossBtn.svg"
import warning from "assets/images/Warning.svg"
import greenCheck from "assets/images/CheckSquare.svg"

function ComplianceUpload(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const minDate = dateFormate(new Date(),'YYYY-MM-DD')
  const [image, setImage] = useState(null);
  const [close, setclose] = useState(true);
  const [formValidation, setFormValidation] = useState({});

  const onBoardComplianceData = useSelector((state) => state.userOnBoardCompliance?.userOnBoardCompliance);
  const vehicledata = useSelector((state) => state.userAddVehicle?.userAddVehicle.data)
  const rejectedData = onBoardComplianceData?.data?.filter((val, idx) => val?.complianceValue[0]?.status === 'Rejected')
  const UploadedData = onBoardComplianceData?.data?.filter((val, idx) => val?.complianceValue[0]?.status === 'Uploaded')
  const ExpiredData = onBoardComplianceData?.data?.filter((val, idx) => val?.complianceValue[0]?.isExpired === true)
  
  const addOnBoardCompliance = useSelector((state) => state?.userAddOnBoardCompliance?.userAddOnBoardCompliance?.success)
  const addComplianceLoader = useSelector(
    (state) => state?.userOnBoardCompliance?.loading
  );
  const updateComplianceLoader = useSelector(
    (state) => state?.userAddOnBoardCompliance?.loading
  );
  const [licenseNumberEdited, setLicenseNumberEdited] = useState(false);
  
  const [formDataIntialise, setFormDataIntialise] = useState([{ licenseNumber: '', expiryDate: '', imageName: null  }]);

  const [fileSizeError, setFileSizeError] = useState(Array(formDataIntialise.length).fill(false));
  const [fileTypeError, setFileTypeError] = useState(Array(formDataIntialise.length).fill(false));

  const complianceData = onBoardComplianceData?.data || [];

// Check if all mandatory items have 'Approved' status
const allMandatoryApproved = complianceData
  .filter((item) => item.isMandatory) // Filter only mandatory items
  .every((item) => item.complianceValue[0]?.status === 'Approved');


  useEffect(() => {
    if(props?.tabName !== 'vehicle'){
      dispatch(getOnBoardCompliance());
    }
    const statusCompliance = localStorage.getItem('status')
    if(statusCompliance === 'Active' && props?.tabName !== 'Self'&& props?.tabName !== 'vehicle'){
      navigate('/dashboard')
    }
  }, []); 

  const fileSize = (file) => {
    const sizeInBytes = file.size;
    return sizeInBytes;
  };

  const handleFileChange = (event, idx) => {
    setFileSizeError('')
    setFileTypeError('')
    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files; // Get the array of selected files
      const attributeType = onBoardComplianceData?.data[idx]?.attributeType;

      const allowedFileTypesForAttributeType = attributeType === 'File' 
      ? ['image/jpeg', 'image/png', 'application/pdf'] 
      : ['image/jpeg', 'image/png'];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!allowedFileTypesForAttributeType.includes(file.type)) {
          // Check if the file type is not allowed
          setFileTypeError((prevErrors) => {
            const updatedErrors = [...prevErrors];
            updatedErrors[idx] = true;
            return updatedErrors;
          });
          // Clear the imageName when a file type error occurs
          setFormDataIntialise((prevFormData) => {
            const updatedFormData = [...prevFormData];
            updatedFormData[idx] = { ...updatedFormData[idx], imageName: ' ' };
            return updatedFormData;
          });
  
          return; // Exit the function
        }

        if (fileSize(file) > complianceObject.fileSize) {
          setFileSizeError((prevErrors) => {
            const updatedErrors = [...prevErrors];
            updatedErrors[idx] = true;
            return updatedErrors;
          });
          setFormDataIntialise((prevFormData) => {
            const updatedFormData = [...prevFormData];
            updatedFormData[idx] = { ...updatedFormData[idx], imageName: ' ' };
            return updatedFormData;
          });
  
          return;
        }
      }

      setFormDataIntialise((prevFormData) => {
        const updatedFormData = [...prevFormData];
        const imageNames = [];
        for (let i = 0; i < files.length; i++) {
          imageNames.push(files[i].name);
        }
        updatedFormData[idx] = { ...updatedFormData[idx], imageName: imageNames.join(', ') };
        return updatedFormData;
      });
  
      // For handling only one file in 'File' attribute type
      if (onBoardComplianceData?.data[idx]?.attributeType === 'File' && files.length === 1) {
        setImage(files[0]); // Store the selected file
      } else {
        setImage(files); // Store the selected files
      }
    }
  };

  const complainceClick = (attributeId, idx) => {
    const filteredData = formDataIntialise[idx];
  
    // Create a new FormData instance
    const formDataDetail = new FormData();
    if (onBoardComplianceData?.data[idx]?.attributeType === 'File') {
      formDataDetail.append('complianceFile', image || "");
    } 
    else if(onBoardComplianceData?.data[idx]?.attributeType === 'Image'){
      formDataDetail.append('complianceFile', image[0] || "");
    }
    else if(onBoardComplianceData?.data[idx]?.attributeType === 'Multi-Image') {
      for (let i = 0; i < image?.length; i++) {
        formDataDetail.append('complianceFile', image[i] || "");
      }
    }
    formDataDetail.append('complianceAttributeId', attributeId);

    if (!filteredData?.licenseNumber) {
      const attributeValue = onBoardComplianceData?.data[idx]?.complianceValue[0]?.atributeValue || '';
      formDataDetail.append('complianceValue', attributeValue);
    } else {
      formDataDetail.append('complianceValue', filteredData?.licenseNumber);
    }

    let selectedVehicleId = ''
    if(props?.tabName === 'vehicle'){
      selectedVehicleId = props?.vehicleId || vehicledata[0]?.vehicleId;
    }
  if (selectedVehicleId ) {
    formDataDetail.append('vehicleId', selectedVehicleId );
  }
    if (onBoardComplianceData?.data?.[idx]?.isExpiring === true) {
      if (!filteredData?.expiryDate) {
        const expiryValue = onBoardComplianceData?.data[idx]?.complianceValue[0]?.expiryDate || '';
        formDataDetail.append('expiryDate', expiryValue);
      } else {
        formDataDetail.append('expiryDate', filteredData?.expiryDate);
      }
    }
  
    dispatch(postAddOnBoardCompliance(formDataDetail));
    if(addOnBoardCompliance ==='true'){
    setImage(null)}
  };

  const handleInput = (e, idx, element) => {
    const { name, value } = e.target;
    if (name === 'licenseNumber') {
      setLicenseNumberEdited(true);
    }

    setFormDataIntialise((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[idx] = { ...updatedFormData[idx], [name]: value};
      return updatedFormData;
    });

    if(element?.ComplianceValidation?.id) {
      const regexTemplate = new RegExp(element?.ComplianceValidation?.value) 
      let errorData = ""

      if(e.target.value) {
        if(!regexTemplate.exec(e.target?.value?.toUpperCase())) {
          errorData = {...formValidation, [element?.attributeName]: true, [`${element?.attributeName}-msg`]: element?.ComplianceValidation?.description}
        }
        else {
          errorData = {...formValidation, [element?.attributeName]: false}
       }
      }
      else {
        errorData = {...formValidation, [element?.attributeName]: false}
     }   
      setFormValidation(errorData);
    }
  };

  const isInputEmpty = (idx, formFieldError, element) => {

    const formData = formDataIntialise[idx];
    const imageType = element?.attributeType === "text" ? true : formData?.imageName;
    const expiryType = element?.isExpiring ? formData?.expiryDate : true;    

    if(formData?.licenseNumber && imageType && expiryType && !formFieldError) {
      return false
    }
    else {
      return true
    }

  };
  const handleclose = () => {
    setclose(false)
  }

  
  return (
    <div>
       {((addComplianceLoader || updateComplianceLoader) && (props.tabName !== 'vehicle')) ? 
            <div>
            <Loader />
          </div> :
      <Grid container md={12} direction='column' className='marginBlock10'>
        {close && (rejectedData?.length > 0 || ExpiredData?.length >0) && 
        <Grid container direction='row' justifyContent='space-between' alignItems='center' className='backgroundRejected'>
          
          <Grid item xs={10}>
          {rejectedData?.map(val =>
          <ul className='colorDarkRed marginBlock30' key={val.id}>
            <li>{val.attributeName+": "+val?.complianceValue[0]?.rejectionReason}</li>
          </ul>)}
          {ExpiredData?.map(val =>
          <ul className='colorDarkRed marginBlock30' key={val.id}>
            <li>{val.attributeName+": "+'Expired'}</li>
          </ul>)}
          </Grid>
          <Grid item xs={1} className='vendorIcons'>
          <img src={closebtn} alt='close' onClick={handleclose} className='cursor padding10'/>
          </Grid>
        </Grid>}
        
        <Grid item>
        {allMandatoryApproved ? (
        <Typography className={`font18 fw400 colorGreen marginBottom25 ${props?.tabName === 'Self' && 'font18'} `}>Your Compliances have been verified</Typography>
      ) : UploadedData?.length > 0 ? ( 
        <Typography className={`font18 fw400 colorYellow marginBottom25${props?.tabName === 'Self' && 'font18'} `}>Your Compliances is under verifications</Typography>
      ) :(
        <Typography className={`font18 fw400 colorGrey marginBottom25 ${props?.tabName === 'Self' &&  'font18'} `}>You need to upload your Compliances as given below for verification</Typography>
      )}
        </Grid>
        {props.tabName === 'vehicle' ? (onBoardComplianceData?.data?.map((ele, idx) => (
          <Grid
            item
            container
            md={12}
            key={idx}
            direction='column'
            className='complianceUploadModal'
          >
            <Grid item className={`complianceColor ${ele?.complianceValue[0]?.status === 'Rejected' ? 'borderRed': ''}`}>
              <Typography className='font18 colorBlue flexStart'>
                {ele?.complianceValue[0]?.status === 'Rejected' ? (
                <img src={warning} alt='rejected' className='width20 marginRight6' />
                ): ele?.complianceValue[0]?.status === 'Approved' ? (
                  <img src={greenCheck} alt='approved' className='width20 marginRight6' />
                ):""}
                {ele?.attributeName} {ele?.isMandatory && <span className='colorRed'>*</span>}</Typography>
              <Grid
                item
                container
                direction='row'
                justifyContent='space-between'
                alignItems='flex-end'
                className='margin10'
              >
                {ele?.attributeType === 'File' ? (
                  <Grid item md={12} className='mrb10'>
                    {(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected'|| ele?.complianceValue[0]?.isExpired === true) &&
                    <Button
                      variant="contained"
                      component="label"
                      className='uploadBtnCompliance'
                    >
                      
                      <Typography>Upload File </Typography> <FileUploadOutlinedIcon />
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg, image/png, application/pdf"
                        onChange={(event) => handleFileChange(event, idx)}
                      />
                    </Button>}
                    {formDataIntialise[idx]?.imageName && formDataIntialise[idx]?.imageName !== null ? ( 
                      <Typography className={(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected') ? 'font14' : 'font16'}><Tooltip title={formDataIntialise[idx].imageName} placement='bottom'>{truncateComment(formDataIntialise[idx].imageName,20)}</Tooltip></Typography>
                    ) : (
                      <Typography>
                        {ele?.complianceValue?.length > 0 && ele.complianceValue[0]?.complianceFile?.name
                            ? (<Tooltip title={ele.complianceValue[0].complianceFile.name} placement='bottom'>{truncateComment(ele.complianceValue[0].complianceFile.name,15)}</Tooltip>) : ""}
                      </Typography>
                    )}
                       {fileSizeError[idx] && (
                      <Typography className="colorRed">File size should not exceed 1 MB</Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="colorRed">selected File Type Not Allowed</Typography>
                    )}
                  </Grid>
                ) : null}
                {ele?.attributeType === 'Image' ? (
                  <Grid item md={12} className='mrb10'>
                    {(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected'|| ele?.complianceValue[0]?.isExpired === true) &&<Button
                      variant="contained"
                      component="label"
                      className='uploadBtnCompliance'
                    >
                      <Typography>Upload File </Typography> <FileUploadOutlinedIcon />
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg, image/png"
                        onChange={(event) => handleFileChange(event, idx)}
                      />
                    </Button>}
                    {formDataIntialise[idx]?.imageName && formDataIntialise[idx]?.imageName !== null ? ( // Check if file name is present
                      <Typography className='font14'><Tooltip title={formDataIntialise[idx].imageName} placement='bottom'>{truncateComment(formDataIntialise[idx].imageName,20)}</Tooltip> </Typography>
                    ) : 
                    (
                      <Typography>
                        {ele?.complianceValue?.length > 0 && ele.complianceValue[0]?.complianceFile?.name
                          ? (<Tooltip title={ele.complianceValue[0]?.complianceFile?.name} placement='bottom'>{truncateComment(ele.complianceValue[0]?.complianceFile?.name,25)}</Tooltip>) : ""}
                      </Typography>
                    )}
                       {fileSizeError[idx] && (
                      <Typography className="colorRed">File size should not exceed 1 MB</Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="colorRed">selected File Type Not Allowed</Typography>
                    )}
                  </Grid>
                ) : ele?.attributeType === 'Multi-Image' ? (
                  <Grid item md={12} className='mrb10'>
                    {(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected'|| ele?.complianceValue[0]?.isExpired === true) &&<Button
                      variant="contained"
                      component="label"
                      className='uploadBtnCompliance'
                    >
                      <Typography>Upload File </Typography> <FileUploadOutlinedIcon />
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg, image/png"
                        multiple
                        onChange={(event) => handleFileChange(event, idx)}
                      />
                    </Button>}
                    {formDataIntialise[idx]?.imageName && formDataIntialise[idx]?.imageName !== null ? ( // Check if file name is present
                      <Typography className='font14'><Tooltip title={formDataIntialise[idx].imageName} placement='bottom'>{truncateComment(formDataIntialise[idx].imageName,20)}</Tooltip> </Typography>
                    ) : 
                    (
                      <Typography>
                        {ele?.complianceValue?.length > 0 && ele.complianceValue[0]?.complianceFile?.name
                          ? (ele?.complianceValue?.map((val,index) => (<Tooltip title={val?.complianceFile?.name} placement='bottom'>{truncateComment(val?.complianceFile?.name,25)+", "}</Tooltip>))) : ""}
                      </Typography>
                    )}
                       {fileSizeError[idx] && (
                      <Typography className="colorRed">File size should not exceed 1 MB</Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="colorRed">selected File Type Not Allowed</Typography>
                    )}
                  </Grid>
                ) : null}
                  <Grid item md={12} className='mrb10'>
                    <InputLabel htmlFor="expiry-date-input">{ele?.attributeType === 'File' && ele?.attributeName ? ele?.attributeName+' Number' : ele?.attributeName}</InputLabel>
                    <TextField
                      className='marginTop width100 bgWhite licenseTextField'
                      size='small'
                      type='text'
                      placeholder={`Enter ${ele?.attributeName}`}
                      value={(formDataIntialise[idx]?.licenseNumber || ele.complianceValue[0]?.atributeValue )|| ''}
                      name='licenseNumber'
                      onChange={(event) => handleInput(event, idx, ele)}
                      disabled={(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? false : true}
                    />
                  {formValidation?.[ele?.attributeName] && <Typography className='errorMessage'>{formValidation?.[`${ele?.attributeName}-msg`]}</Typography>}
                  </Grid>
                {ele?.isExpiring === true && (
                  <Grid item md={12} className='mrb10'>
                    <InputLabel htmlFor="expiry-date-input">Expiry Date</InputLabel>
                    <TextField
                      className='marginTop width100 bgWhite'
                      size='small'
                      type='date'
                      value={(formDataIntialise[idx]?.expiryDate ||  ele.complianceValue[0] && dateFormate(ele.complianceValue[0]?.expiryDate,'YYYY-MM-DD'))|| ' '}
                      name='expiryDate'
                      onChange={(event) => handleInput(event, idx)}
                      InputProps={{inputProps: { min: minDate, max: dateObject.maxDate} }}
                      disabled={(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? false : true}
                    >
                      Expiry Date
                    </TextField>
                  </Grid>
                )}
                {(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? <Grid item className='mrb10'>
                  <Button className={`uploadComplianceBtn ${
                    !formValidation?.[ele?.attributeName] && !isInputEmpty(idx, formValidation?.[ele?.attributeName], ele) ? 'buttonSubmit': 'buttonSubmitDisabled'}`}
                    disabled={isInputEmpty(idx, formValidation?.[ele?.attributeName], ele)} 
                    onClick={() => complainceClick(ele?.id, idx)}
                    >
                    Save
                  </Button>
                </Grid> : ''}
              </Grid>
            </Grid>
          </Grid>
        ))) : (props?.tabName !== 'vehicle' && onBoardComplianceData?.data?.map((ele, idx) => (      
          <Grid
            item
            container
            md={12}
            key={idx}
            direction='column'
            className='complianceUpload'
          >
            <Grid item className={`complianceColor ${ele?.complianceValue[0]?.status === 'Rejected' ? 'borderRed': ele?.complianceValue[0]?.isExpired === true ? 'borderYellow':''}`}>
              <Typography className='font18 colorBlue flexStart'>
                {ele?.complianceValue[0]?.status === 'Rejected' ? (
                <img src={warning} alt='rejected' className='width20 marginRight6' />
                ): ele?.complianceValue[0]?.status === 'Approved' ? (
                  <img src={greenCheck} alt='approved' className='width20 marginRight6' />
                ):""}
                {ele?.attributeName} {ele?.isMandatory && <span className='colorRed'>*</span>}</Typography>
              <Grid
                item
                container
                direction='row'
                justifyContent={(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? 'space-between': 'flex-start' }
                alignItems='flex-end'
                className='margin10' xs={12} md={12}
              >
                {ele?.attributeType === 'File' ? (
                  <Grid item md={ele?.attributeType === 'File' ? 3 :(ele?.attributeType && !ele?.isExpiring) ? 5 : !ele?.isExpiring ? 5 : 3} sm={12} className='mr10'>
                    {(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected'|| ele?.complianceValue[0]?.isExpired === true) &&
                    <Button
                      variant="contained"
                      component="label"
                      className='uploadBtnCompliance'
                    >
                      <Typography>Upload File </Typography> <FileUploadOutlinedIcon />
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg, image/png, application/pdf"
                        onChange={(event) => handleFileChange(event, idx)}
                      />
                    </Button>}
                    {formDataIntialise[idx]?.imageName && formDataIntialise[idx]?.imageName !== null ? ( 
                      <Typography className={(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected') ? ' positionAbsoulte font14' : 'font16'}><Tooltip title={formDataIntialise[idx].imageName} placement='bottom'> {truncateComment(formDataIntialise[idx].imageName,20)}</Tooltip></Typography>
                    ) : (
                      <Typography>
                        {ele?.complianceValue?.length > 0 && ele.complianceValue[0]?.complianceFile?.name
                            ?(<Tooltip title={ele.complianceValue[0]?.complianceFile?.name} placement="bottom">{truncateComment(ele.complianceValue[0].complianceFile.name,15)}</Tooltip>)  : ""}
                      </Typography>
                    )}
                    {fileSizeError[idx] && (
                      <Typography className="positionAbsoulte colorRed">File size should not exceed 1 MB</Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="positionAbsoulte colorRed">selected File Type Not Allowed</Typography>
                    )}
                  </Grid>
                ) : null}
                {ele?.attributeType === 'Image' ? (
                  <Grid item md={ele?.attributeType === 'Image' ? 3 :( !ele?.isExpiring) ? 5  : 3} sm={12} className='mr10'>
                    {(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected' || ele?.complianceValue[0]?.isExpired === true) &&<Button
                      variant="contained"
                      component="label"
                      className='uploadBtnCompliance'
                    >
                      <Typography>Upload File </Typography> <FileUploadOutlinedIcon />
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg, image/png"
                        multiple
                        onChange={(event) => handleFileChange(event, idx)}
                      />
                    </Button>}
                    {formDataIntialise[idx]?.imageName && formDataIntialise[idx]?.imageName !== null ? ( // Check if file name is present
                      <Typography className='positionAbsoulte font14'><Tooltip title={formDataIntialise[idx].imageName} placement='bottom'>{truncateComment(formDataIntialise[idx].imageName,20)}</Tooltip> </Typography>
                    ) : (
                      <Typography className={(!ele?.complianceValue[0]?.complianceFile?.name || ele?.complianceValue[0]?.status === 'Rejected') ? 'positionAbsolute font14': 'font16'}>
                        {ele?.complianceValue?.length > 0 && ele.complianceValue[0]?.complianceFile?.name
                          ?(<Tooltip title={ele.complianceValue[0]?.complianceFile?.name} placement="bottom">{ truncateComment(ele.complianceValue[0]?.complianceFile?.name,20)}</Tooltip>) : ""}
                      </Typography>
                    )}
                    {fileSizeError[idx] && (
                      <Typography className="positionAbsoulte colorRed">File size should not exceed 1 MB</Typography>
                    )}
                    {fileTypeError[idx] && (
                      <Typography className="positionAbsoulte colorRed">selected File Type Not Allowed</Typography>
                    )}

                  </Grid>
                ) : null}
                  <Grid item md={ele?.attributeType === 'File' ? 3 :( !ele?.isExpiring)  ? 5 : 3} sm={12} className='mr10'>
                    <InputLabel htmlFor="expiry-date-input">{ele?.attributeType === 'File' && ele?.attributeName ? ele?.attributeName+' Number' : ele?.attributeName}</InputLabel>
                    <TextField
                      className='marginTop width100 bgWhite licenseTextField'
                      size='small'
                      type='text'
                      placeholder={`Enter ${ele?.attributeName}`}
                      value={licenseNumberEdited ? formDataIntialise[idx]?.licenseNumber : ele.complianceValue[0]?.atributeValue}
                      name='licenseNumber'
                      onChange={(event) => handleInput(event, idx, ele)}
                      disabled={(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? false : true}
                    />
                  </Grid>
                {ele?.isExpiring === true && (
                  <Grid item md={ele?.attributeType === 'File' ? 3 : 3} sm={12} className='mr10'>
                    <InputLabel htmlFor="expiry-date-input">Expiry Date</InputLabel>
                    <TextField
                      className='marginTop width100 bgWhite'
                      size='small'
                      type='date'
                      value={formDataIntialise[idx]?.expiryDate ||  ele.complianceValue[0] && dateFormate(ele.complianceValue[0]?.expiryDate,'YYYY-MM-DD')}
                      name='expiryDate'
                      onChange={(event) => handleInput(event, idx)}
                      InputProps={{inputProps: { min: minDate, max: dateObject.maxDate} }}
                      disabled={(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? false : true}
                    >
                      Expiry Date
                    </TextField>
                  </Grid>
                )}
                {(ele?.complianceValue[0]?.isExpired === true) || (ele?.complianceValue[0]?.status !== 'Approved' && ele?.complianceValue[0]?.status !== 'Uploaded') ? <Grid item >
                  <Button className={`uploadComplianceBtn ${
                    !formValidation?.[ele?.attributeName] && !isInputEmpty(idx, formValidation?.[ele?.attributeName], ele)
                    ? 'buttonSubmit': 'buttonSubmitDisabled'}`}
                   disabled={isInputEmpty(idx, formValidation?.[ele?.attributeName], ele)}
                   onClick={() => complainceClick(ele?.id, idx)}
                  >
                    Save
                  </Button>
                </Grid>: ''}
              </Grid>
              {formValidation?.[ele?.attributeName] && <Typography className='errorMessage'>{formValidation?.[`${ele?.attributeName}-msg`]}</Typography>}
            </Grid> 
          </Grid>
        )))}
      </Grid>}
    </div>
  );
}
export default ComplianceUpload;




